import React, { useEffect, useRef } from 'react';
import styles from './styles.scss';
import { Col, Row, Container } from '../../components/Grid';
import Icon from 'Components/Icon';
import Link from 'Components/Link';
import Typography from 'Components/Typography';

export const FormErrorModal = ({ dealer }) => {
  const headlineRef = useRef(null);
  const whatsappUrl = dealer.settings.whatsappWidget.whatsappUrl;
  const phone = dealer.dealerLocations[0].phone;
  const email = dealer.dealerLocations[0].email;

  useEffect(() => {
    headlineRef?.current.focus();
  }, []);

  return (
    <Container>
      <Row>
        <Col cols={12}>
          <Typography.Headline
            ref={headlineRef}
            value="Fehler beim Absenden"
            className={styles.deactivatedHeadline}
            level="h2"
            forceUppercase={true}
            additionalProps={{
              id: 'modal-redesign-headline',
              'aria-live': 'assertive',
              role: 'alert',
              tabIndex: '-1',
            }}
          />
        </Col>

        <Col cols={12} className={styles.deactivatedText}>
          <p>
            Ihre Anfrage kann leider im Moment nicht übermittelt werden. Wir arbeiten gerade an der
            Ursache.
          </p>
          <p>
            Versuchen Sie es zu einem späteren Zeitpunkt bitte noch einmal oder kontaktieren Sie uns
            direkt:
          </p>
        </Col>

        <Col cols={12}>
          <div className={styles.deactivatedMessageSeparationLine}></div>
        </Col>

        <Col cols={12}>
          <ul className={styles.deactivatedAddress}>
            <li className={styles.deativatedContactRow}>
              <Typography.Headline
                value={dealer.name}
                className={styles.dealerName}
                level="h3"
                forceUppercase={true}
              />
            </li>
            <li className={styles.deativatedContactRow}>
              <span className={styles.iconWrapper}>
                <Icon name="phone" />
              </span>

              <div className={styles.deativatedContactText}>
                <Link
                  to={`tel:${phone}`}
                  ariaLabel={`Telefonnummer ${phone.substring(0, 3) === '+49' && 'Deutschland'} ${phone} anrufen`}
                >
                  {phone}
                </Link>
              </div>
            </li>
            <li className={styles.deativatedContactRow}>
              <span className={styles.iconWrapper}>
                <Icon name="mail" />
              </span>

              <div className={styles.deativatedContactText}>
                <Link to={`mailto:${email}`} ariaLabel={`E-Mail an ${email} senden`}>
                  {email}
                </Link>
              </div>
            </li>

            {whatsappUrl && (
              <li className={styles.deativatedContactRow}>
                <span className={styles.iconWrapper}>
                  <img
                    role="presentation"
                    className={styles.whatsappIcon}
                    src={`${process.env.ASSET_ENV_HOST}/assets/img/icon_whatsapp_green.svg`}
                  />
                </span>

                <div className={styles.deativatedContactText}>
                  <Link to={whatsappUrl} target="_blank" isExternal>
                    WhatsApp Chat starten
                  </Link>
                </div>
              </li>
            )}
          </ul>
        </Col>
      </Row>
    </Container>
  );
};
